import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams, useOutletContext } from "react-router-dom";
import Header from "../../component/Header";
import Footer from "../../component/Footer";
import HeadingSkeleton from "../../component/HeadingSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { NotificationManager } from "react-notifications";

const FairTradeAboutUs = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const { storeId } = useParams();

  // Get store context from StoreLayout
  const outletContext = useOutletContext();
  const store = outletContext?.store;
  const isWishlisted = outletContext?.isWishlisted;
  const favouriteId = outletContext?.favouriteId;

  const [allDetails, setAllDetails] = useState();
  const [openModal, setOpenModal] = useState();
  const [aboutData, setAboutData] = useState();
  const [loading, setLoading] = useState(true);


  const fetchDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/store/about-us`, {
        method: "POST",
        body: JSON.stringify({
          store_id: storeId,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.authorisation?.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAboutData(responseData.data);
      } else {
        NotificationManager.warning(responseData?.msg);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleAddStore = async () => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/liked-stores`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          // setResponseStatus(responseData?.msg);
          NotificationManager.success(responseData?.msg);
        } else {
          // setResponseStatus(responseData?.msg);
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  const handleRequestPrice = async () => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/request-price`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
            lang: selectedLanguage,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          NotificationManager.success(responseData?.msg);
        } else {
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  useEffect(() => {
    //fetchStoreDetails();
    fetchDetails();
  }, []);

  return (
    <div className="fullContainer">
      <div className="categoryDiv productSliderMain topNew tradePrdts">
        <div className="featureDiv productListMain">
          {loading ? (
            <>
              <HeadingSkeleton width="200px" height="28px" />
              <div style={{ marginTop: "20px" }}>
                <div className="skeleton" style={{ height: "20px", width: "100%", marginBottom: "12px" }} />
                <div className="skeleton" style={{ height: "20px", width: "95%", marginBottom: "12px" }} />
                <div className="skeleton" style={{ height: "20px", width: "98%", marginBottom: "12px" }} />
                <div className="skeleton" style={{ height: "20px", width: "92%", marginBottom: "12px" }} />
                <div className="skeleton" style={{ height: "20px", width: "96%", marginBottom: "12px" }} />
                <div className="skeleton" style={{ height: "20px", width: "90%", marginBottom: "12px" }} />
              </div>
            </>
          ) : (
            <>
              <h2 className="storeTabHdn">{langJson?.aboutus}</h2>
              <div className="aboutDiv" dangerouslySetInnerHTML={{ __html: aboutData?.about_us }} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FairTradeAboutUs;
